/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Backgrounds from './Backgrounds';
import Section from './Section';
import sections from '../sections';

import styles from '../../../../styles/guest/partials/sections.module.scss';

const propTypes = {
    currentIndex: PropTypes.number,
    scrollToIndex: PropTypes.number,
    onChange: PropTypes.func,
    sectionProps: PropTypes.object, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    currentIndex: null,
    scrollToIndex: null,
    onChange: null,
    sectionProps: null,
    className: null,
};

const Sections = ({ currentIndex, scrollToIndex, onChange, sectionProps, className }) => {
    const onSectionChange = useCallback(
        (sectionIndex) => {
            if (onChange !== null) {
                onChange(sectionIndex);
            }
        },
        [currentIndex, onChange],
    );

    return (
        <main
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Backgrounds className={styles.backgrounds} currentIndex={currentIndex} />
            <article className={styles.sections}>
                {sections.map(({ slug, theme, Section: SectionComponent }, sectionIndex) => {
                    const active = currentIndex === sectionIndex;
                    return (
                        <Section
                            key={`section-${slug}`}
                            className={classNames([
                                styles.section,
                                {
                                    [styles.active]: active,
                                    [styles[`${theme}Theme`]]: theme !== null,
                                },
                            ])}
                            scrollTo={scrollToIndex === sectionIndex}
                            onChange={() => {
                                onSectionChange(sectionIndex);
                            }}
                        >
                            <SectionComponent {...sectionProps} active={active} />
                        </Section>
                    );
                })}
            </article>
        </main>
    );
};

Sections.propTypes = propTypes;
Sections.defaultProps = defaultProps;

export default Sections;
